/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantResponse
 */
export interface TenantResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    disbursementCallbackUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    refundCallbackUrl?: string | null;
}

/**
 * Check if a given object implements the TenantResponse interface.
 */
export function instanceOfTenantResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantResponseFromJSON(json: any): TenantResponse {
    return TenantResponseFromJSONTyped(json, false);
}

export function TenantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disbursementCallbackUrl': !exists(json, 'disbursement_callback_url') ? undefined : json['disbursement_callback_url'],
        'refundCallbackUrl': !exists(json, 'refund_callback_url') ? undefined : json['refund_callback_url'],
    };
}

export function TenantResponseToJSON(value?: TenantResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disbursement_callback_url': value.disbursementCallbackUrl,
        'refund_callback_url': value.refundCallbackUrl,
    };
}

